<ng-template let-entity="entity" #actionsTemplate>
  <a (click)="openEditGroupDialog(entity)" id="edit_group" i18n-ngbTooltip="@@EditChargingGroupsTooltip" ngbTooltip="Gruppe bearbeiten" class="btn btn-sm btn-yellow ms-1">
    <span data-bs-toggle="modal" data-bs-target="#editGroup">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
      </svg>
    </span>
  </a>
  <a [routerLink]="['delete', entity.id]" id="delete_group" class="btn btn-sm btn-yellow ms-1" i18n-ngbTooltip="@@DeleteChargingGroupsTooltip" ngbTooltip="Gruppe löschen">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash">
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    </svg>
  </a>
</ng-template>

<div class="clearfix">
  <form class="float-start">
    <div i18n="@@Search" style="min-width:200px;">
      <input class="form-control" id="table_search" type="text" name="searchTerm" [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
    </div>
  </form>
  <div class="float-end mb-1 btn-group">
    <div class="float-end mb-1">
      <a class="btn btn-yellow" id="creat_new_group" *ngIf="permissions?.chargingstationGroupsCreate" data-bs-toggle="modal" data-bs-target="#newGroup" (click)="openCreateGroupDialog()" data-bs-placement="left">
        <app-svg source="icons/feather/plus-circle" height="18"></app-svg>
        <span class="d-none d-md-inline ps-2" i18n="@@CreateNewGroupButton">Neue Gruppe erstellen</span>
      </a>
    </div>
  </div>
</div>

<div *ngIf="tableReady">
  <app-table [table]="table"></app-table>
</div>

<div *ngIf="!tableReady" class="loading-spinner-container">
  <div class="spinner-border text-primary loading-spinner-md" role="status">
    <span class="visually-hidden-focusable" i18n="@@Loading">Loading...</span>
  </div>
</div>

<router-outlet></router-outlet>
